module.exports = __webpack_public_path__ + "media/images/1-69067f8ef14af61129e7997b1b4fa9bf.jpg";